import { useTenant } from "@/hooks/useTenant";
import { portalFetch } from "@/lib/portalApi";
import { useCallback } from "react";

/**
 * Returns a fire-and-forget `track(event, properties?)` function
 * that POSTs to the portal events API. Silent on failure —
 * analytics should never break the app.
 */
export function useTrack() {
  const { currentTenantId } = useTenant();

  return useCallback(
    (event: string, properties?: Record<string, unknown>) => {
      if (!currentTenantId) return;
      void portalFetch(`/api/portal/tenants/${currentTenantId}/events`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tenantId: currentTenantId, event, properties }),
      }).catch(() => {});
    },
    [currentTenantId],
  );
}
